import React from 'react'
import Home from './Home';
import Skills from './Skills';
import Portfolio from './Portfolio';
import Navbar from './Navbar';

const Main = () => {
  return (
    <div>
        <Home />
        <Skills />
        <Portfolio />
    </div>
  )
}

export default Main